import InjuryReportPage from "@/app/(app)/(crew)/reports/(injury)/index";

export default InjuryReportPage;
